import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

var routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "./views/About.vue")
  },
  {
    path: "/ourProducts/alphaGanith",
    name: "alphaGanith",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "AlphaGanith" */ "./views/ourProducts/AlphaGanith.vue")
  },
  {
    path: "/ourProducts/mathematicalLaboratory",
    name: "mathematicalLaboratory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "MathematicalLaboratory " */ "./views/ourProducts/MathematicalLaboratory.vue")
  },
  {
    path: "/ourProducts/isrtApp",
    name: "isrtApp",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ISRTApp " */ "./views/ourProducts/ISRTApp.vue")
  },
  {
    path: "/productDetail/:productId",
    // path: '/productDetail',
    name: "productDetail",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ProductDetail" */ "./views/ProductDetail.vue")
  },
  {
    path: "/contact",
    // path: '/productDetail',
    name: "contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "contact" */ "./views/Contact.vue")
  }
];
const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes,
  linkActiveClass: "activeLink",
  linkExactActiveClass: "exact-activeLink"
});
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
